import { render, staticRenderFns } from "./deletar.vue?vue&type=template&id=5dfb4f77&"
import script from "./deletar.vue?vue&type=script&lang=js&"
export * from "./deletar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports